import { useState, useEffect } from 'react';
import i18n from '../../../../utils/translations/i18n';
import { ReactComponent as HoverToZoom } from '../../../../assets/icons/hover-to-zoom.svg';
import { ReactComponent as HoverToZoomNew } from '../../../../assets/icons/hover-to-zoom-new.svg';
import PreviewPopup from '../../sections/preview-popup';
import { RootState } from "../../../../store";
import { useSelector } from "react-redux";
import { Page } from "../../../../enums/page";

const UsgProductDetails = ({ productName, productImageUrl, isMobileDevice}) => {
  const { t } = i18n;
  const [styleObj, setPopupStyle] = useState({});
  const [showModal, setShowModal] = useState(false);
  let usgClassName = '';
  let usgWrapperClassName = 'usg-product-image-info';
  const {
    applicationState: { currentPage },
  } = useSelector((state: RootState) => state);

  const hideModal = () => {
    setShowModal(false)
  }

  useEffect(() => {
    if(!isMobileDevice) {
      let previewPopupStartingPosition = document.querySelector('.col-sm-7');
      if(currentPage === Page.CHECKOUTSHIPPING) {
        previewPopupStartingPosition = document.querySelector('.summary-order-details');
      } else if(currentPage === Page.CHECKOUTPAYMENT) {
        previewPopupStartingPosition = document.querySelector('.col-lg-4');
      } else if(currentPage === Page.SHOPPINGBAG) {
        previewPopupStartingPosition = document.querySelector('.usg-product-image-info');
      }
      const previewPopupPosition = previewPopupStartingPosition?.getBoundingClientRect();
      if(previewPopupPosition?.x) {
        const distanceFromRightEdge = window.innerWidth - previewPopupPosition.left;
        if(currentPage === Page.CHECKOUTSHIPPING && distanceFromRightEdge) {
          setPopupStyle({ left: 'auto', right: distanceFromRightEdge + 15 + 'px', transform: 'translateY(-50%)'});
        } else if(currentPage === Page.CHECKOUTPAYMENT ){
          setPopupStyle({ left: previewPopupPosition.x + 'px', transform: 'translateY(-50%)'});
        } else if(currentPage === Page.SHOPPINGBAG){
          setPopupStyle({ left: previewPopupPosition.right + 15 +  'px', transform: 'translateY(-50%)'});
        }
      }
    }
  },[currentPage, isMobileDevice]);

  if(currentPage === Page.SHOPPINGBAG) {
    usgClassName = 'shopping-bag-usg';
  } else if(currentPage === Page.CHECKOUTPAYMENT) {
    usgClassName = 'checkout-payment';
  } else if(currentPage === Page.ORDERCONFIRMATION || currentPage === Page.ORDERDETAILS) {
    usgClassName = 'order-confirmation';
  }

  if(currentPage === Page.ORDERDETAILS) {
    usgWrapperClassName = 'usg-product-image-info-spa';
  }

  const isClickToZoomApplicable = ((isMobileDevice && currentPage !== Page.ORDERCONFIRMATION) || (currentPage === Page.ORDERCONFIRMATION) || (currentPage === Page.ORDERDETAILS) )?? false;
  const clickToOpenCheckoutPages = () => {
    if (
      isMobileDevice &&
      currentPage &&
      [Page.SHOPPINGBAG, Page.CHECKOUTSHIPPING, Page.CHECKOUTPAYMENT, Page.ORDERCONFIRMATION].includes(currentPage)
    ) {
      setShowModal(true);
    }
  };

  return (
    <div className="usg-product-card-item-image" onClick={clickToOpenCheckoutPages}>
      <div className={`${usgWrapperClassName} image-info ${currentPage}`} onClick={() => isClickToZoomApplicable && setShowModal(true) }>
        <img
          className="usg-2-item-image"
          alt={productName}
          itemProp="image"
          src={productImageUrl}
          height="100%"
          width="100%"
          data-testid='test-usg-item-image'
        />
      </div>
      <PreviewPopup imprintImageUrl={productImageUrl} usgClass={`${usgClassName} usg-product-hover-image-info`} style={styleObj} showModal={showModal} hideModal={hideModal}/>
      <div className="usg-hover-to-zoom-container" data-testid={`test-${usgClassName}`}>

        {currentPage === Page.ORDERDETAILS ? <HoverToZoom /> : <HoverToZoomNew/>}

        <span className={currentPage !== Page.SHOPPINGBAG ? 'checkout-hover-to-zoom' : ''}>
          {isMobileDevice 
            ? t('shopping_cart_details.tapToZoom') 
            : t(`shopping_cart_details.${currentPage === Page.ORDERCONFIRMATION || currentPage === Page.ORDERDETAILS ? 'clickToZoom' : 'hoverToZoom'}`)
          }
        </span>
      </div>
    </div>
  );
};
export default UsgProductDetails;
